// @flow
import type {
  CommentOperator,
} from '../types'

export default ({operations: []}: {
  operations: Array<CommentOperator>,
})
